import React from "react"
import { Redirect }  from "react-router-dom"
import axios from "axios";
import { reset as API_URL } from "./config/api";
import {
    Form, Icon, Input, Button, Checkbox,
  } from 'antd';


const postUrlLogin = API_URL ;

class ResetPassword extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            name                : "",
            email               : "",
            password            : "",
            fireRedirect        : false,
            fireLoginError      : false,
            resetModal          : false,
            request_send        : ""
        };
        this.getValidateSubmit   = this.getValidateSubmit.bind(this);
        this.handleInputChange   = this.handleInputChange.bind(this);
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;
        this.setState({
            [name]: value,
            fireLoginError : false
        });
    }

    handleLoginClicked = (e) => {
        e.preventDefault();
        this.props.setForgot(false);
    }

    
    getValidateSubmit(data){
        var $self = this;
        var $s = true;
        Object.keys(data).map(function(key) {
            if ( $self.getValidationState(key) !== "success" ){
                $s = false
            }
            return $s
        });
        return $s
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            
        if (!err) {
            let host = window.location.host;
        let parts = host.split(".");
        let subdomain = "";
        if (parts.length >= 3) {
            subdomain = parts[0];
        }else{
            subdomain = 'rcd';
        }

        var $self = this;
        var data = {
            email  : values.email,
            subdomain : subdomain
        };

        var qs = require("qs");
        $self.setState({
            request_send : " hide",
            fireLoginError : false
        })
        axios.post(postUrlLogin, qs.stringify(data))
            .then(function (response) {
                if ( response.data["status"] === "success" ){
                    $self.props.setForgot(false);
                } else if ( response.data["status"] === "error" ){
                    $self.setState({ 
                        fireLoginError : true,
                        request_send: "" 
                    });
                }
                $self.setState({ request_send: "" });
            })
            .catch(function (error) {
                console.log(error);
            });
            }
        });
    }
  
    render(){
    const { getFieldDecorator } = this.props.form;
    return(
        <Form onSubmit={this.handleSubmit} className="container login">
        <h2 className="login_title text-center"></h2>
        <div className="card card-container">
            <div className="form-title">Reset password</div>
            <p className="input_title">Email</p>
            <Form.Item>
            {getFieldDecorator('email', {
                rules: [{
                    type: 'email', message: 'The input is not valid E-mail!',
                  }, {
                    required: true, message: 'Please input your E-mail!',
                  }],
            })(
                <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" placeholder="user01@IceCode.com" />
            )}
            </Form.Item>
            <Button style={{width : '100%', height : '40px'}} type="primary" htmlType="submit" className={"btn btn-lg btn-primary " + this.state.request_send }>
                Reset password
            </Button>
            <span className={"error-login " + (this.state.fireLoginError === true ? "" : "hide")}>
                The username was not found
            </span>
            <div className="forgot">
                <a href="#" onClick={this.handleLoginClicked} >Go to login</a>
            </div>
        </div>
      </Form>
        /*<div className="container login">
            <br /><br />
            <h2 className="login_title text-center"></h2>
            <div className="card card-container">
                <div class="form-title">Reset password</div>
                <form onSubmit={this.handleLoginSubmit} className="form-signin">
                    <span id="reauth-email" className="reauth-email"></span>
                    <p className="input_title">Email</p>
                    <input type="email" id="inputEmail" name="email" className="login_box" value={this.state.emai} placeholder="user01@IceCode.com" onChange={this.handleInputChange} required autoFocus />
                    <button className={"btn btn-lg btn-primary " + this.state.request_send } type="submit">RESET PASSWORD</button>
                    <span className={"error-login " + (this.state.fireLoginError === true ? "" : "hide")}>
                        The username was not found
                    </span>
                    <div className="forgot">
                        <a href="#" onClick={this.handleLoginClicked} >Go to login</a>
                    </div>
                </form>
            </div>
        </div>*/
    )
  }
};
const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(ResetPassword);

export default WrappedNormalLoginForm




// WEBPACK FOOTER //
// ./src/Setup/ResetPassword.js